/**
 * Client-visible configuration. `envDir` in vite.config.ts is the repo root, so these come from
 * the same `.env` the api reads (docs/CONTRACT.md §3). In production both URLs are empty and the
 * console uses same-origin relative paths.
 */

/** API origin, e.g. `https://olmt-call-api.localhost`. Empty string means same-origin. */
export const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL ?? ''

/**
 * The chat app's origin. Invite and recovery links are `WEB_ORIGIN + "/i/" + code` (docs/CONTRACT.md
 * §4) — the api only returns the full `url` when a code is minted, so the list needs the origin to
 * rebuild it. In production this is `https://call.olmt.net`; left empty it disables the copy
 * affordances rather than inventing a host.
 */
export const WEB_ORIGIN: string = (import.meta.env.VITE_WEB_ORIGIN ?? '').replace(/\/+$/, '')
